<!-- Generated template for the DnrsavingsComponent component -->
<!-- <ion-header>
  <ion-navbar>
    <ion-title>
      Ionic Savings
    </ion-title>
    <ion-buttons end>
      <button top right ion-button (click)="gotoSearch($event)" (messageEvent)="receiveMessage($event)">
        <ion-icon padding name="search"></ion-icon>
      </button>
    </ion-buttons>
  </ion-navbar>
</ion-header> -->
<ion-header>
  <ion-navbar>
    <ion-title>
      Ionic Savings
    </ion-title>
  </ion-navbar>
</ion-header>
<ion-content>
  <parent-tabs [index]="tabIndex"></parent-tabs>
</ion-content>
